import { z } from "zod";
import { noAnswerSchema, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  description: z.string().max(2000).optional(),
  collapsible: z.boolean().default(false),
  collapsedByDefault: z.boolean().default(false),
});

export const sectionField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "section",
  label: "Section",
  category: "layout",
  icon: "Rows3",
  configSchema,
  valueSchema: () => noAnswerSchema(),
  defaultConfig: { collapsible: false, collapsedByDefault: false },
  supportsProfileBinding: false,
  defaultSearchable: false,
  renderHints: { isLayoutOnly: true },
};
